import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const API_URL = import.meta.env.VITE_API_URL || "https://eleven11-i6v4.onrender.com";

const STATUS_CONFIG = {
  pending:    { label: "Pending",      color: "#f59e0b", bg: "#fffbeb" },
  approved:   { label: "Approved",     color: "#3b82f6", bg: "#eff6ff" },
  denied:     { label: "Denied",       color: "#ef4444", bg: "#fef2f2" },
  label_sent: { label: "Label Sent",   color: "#8b5cf6", bg: "#f5f3ff" },
  received:   { label: "Received",     color: "#06b6d4", bg: "#ecfeff" },
  credited:   { label: "Credited",     color: "#10b981", bg: "#ecfdf5" },
};

export default function AdminReturnsScreen() {
  const [returns, setReturns]               = useState([]);
  const [loading, setLoading]               = useState(true);
  const [selected, setSelected]             = useState(null);
  const [filter, setFilter]                 = useState("all");
  const [adminNote, setAdminNote]           = useState("");
  const [creditAmt, setCreditAmt]           = useState("");
  const [actionLoading, setActionLoading]   = useState(false);
const [customerCredit, setCustomerCredit] = useState(null);
const [customerInfo, setCustomerInfo]     = useState(null);

  useEffect(() => { fetchReturns(); }, []);

  useEffect(() => {
    if (selected) {
      setAdminNote(selected.adminNote || "");
      setCreditAmt("");
      fetchCustomerCredit(selected.email);
    }
  }, [selected]);

  const token = () => localStorage.getItem("token");

  const fetchReturns = async () => {
    try {
      const res = await fetch(`${API_URL}/api/returns`, {
        headers: { Authorization: `Bearer ${token()}` }
      });
      const data = await res.json();
      setReturns(data.returns || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

const fetchCustomerCredit = async (email) => {
  try {
    const res = await fetch(`${API_URL}/auth/users`, {
      headers: { Authorization: `Bearer ${token()}` }
    });
    const data = await res.json();
    const user = (data.users || []).find(u => u.email === email);
    setCustomerCredit(user?.storeCredit ?? null);
    setCustomerInfo(user || null);
  } catch { setCustomerCredit(null); setCustomerInfo(null); }
};



 const action = async (endpoint, body = {}) => {
  setActionLoading(true);
  const currentEmail = selected.email;
  try {


      const res = await fetch(`${API_URL}/api/returns/${selected._id}/${endpoint}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.success) {
        await fetchReturns();
        const updated = await fetch(`${API_URL}/api/returns`, {
          headers: { Authorization: `Bearer ${token()}` }
        }).then(r => r.json());
        const updatedRet = (updated.returns || []).find(r => r._id === selected._id);
     if (updatedRet) {
          setSelected(updatedRet);
          if (data.newStoreCredit !== undefined) setCustomerCredit(data.newStoreCredit);
          await fetchCustomerCredit(currentEmail);
        }

        
      }
    } catch (err) { console.error(err); }
    setActionLoading(false);
  };

  const filtered = filter === "all" ? returns : returns.filter(r => r.status === filter);
  const pending = returns.filter(r => r.status === "pending").length;

  return (
    <AdminLayout>
      <div style={styles.page}>

        <div style={styles.header}>
          <div>
            <p style={styles.kicker}>ADMIN</p>
            <h1 style={styles.title}>Returns & Support</h1>
          </div>
          {pending > 0 && (
            <div style={styles.pendingBadge}>{pending} Pending Review</div>
          )}
        </div>

        <div style={styles.layout}>

          {/* LEFT: List */}
          <div style={styles.listCol}>
            <div style={styles.filterRow}>
              {["all", "pending", "approved", "denied", "label_sent", "received", "credited"].map(f => (
                <button
                  key={f}
                  style={{ ...styles.filterBtn, ...(filter === f ? styles.filterActive : {}) }}
                  onClick={() => setFilter(f)}
                >
                  {f === "all" ? "All" : STATUS_CONFIG[f]?.label}
                </button>
              ))}
            </div>

            {loading && <div style={styles.empty}>Loading...</div>}
            {!loading && filtered.length === 0 && <div style={styles.empty}>No returns found.</div>}

            {!loading && filtered.map(ret => (
              <div
                key={ret._id}
                style={{ ...styles.card, ...(selected?._id === ret._id ? styles.cardSelected : {}) }}
                onClick={() => setSelected(ret)}
              >
                <div style={styles.cardTop}>
                  <span style={styles.retNumber}>{ret.returnNumber}</span>
                  <StatusBadge status={ret.status} />
                </div>
                <div style={styles.cardOrder}>Order: {ret.orderNumber}</div>
                <div style={styles.cardEmail}>{ret.email}</div>
                <div style={styles.cardReason}>{ret.reason}</div>
                <div style={styles.cardDate}>
                  {new Date(ret.createdAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT: Detail */}
          <div style={styles.detailCol}>
            {!selected ? (
              <div style={styles.emptyDetail}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
                  <rect x="9" y="3" width="6" height="4" rx="1"/>
                </svg>
                <p style={styles.emptyDetailText}>Select a return to view details</p>
              </div>
            ) : (
              <div style={styles.detail}>

                <div style={styles.detailHeader}>
                  <div>
                    <div style={styles.detailNumber}>{selected.returnNumber}</div>
                    <div style={styles.detailSub}>Order {selected.orderNumber}</div>
                  </div>
                  <StatusBadge status={selected.status} large />
                </div>

              <div style={styles.section}>
  <div style={styles.sectionLabel}>CUSTOMER</div>
  <div style={styles.infoRow}>
    <span style={styles.infoKey}>Name</span>
    <span style={styles.infoVal}>
      {customerInfo ? `${customerInfo.firstName || ""} ${customerInfo.lastName || ""}`.trim() : "—"}
    </span>
  </div>
  <div style={styles.infoRow}>
    <span style={styles.infoKey}>Email</span>
    <a href={`mailto:${selected.email}`} style={{ ...styles.infoVal, color: "#6366f1", textDecoration: "none" }}>
      {selected.email}
    </a>
  </div>
  <div style={styles.infoRow}>
    <span style={styles.infoKey}>Phone</span>
    <a href={`tel:${customerInfo?.phone}`} style={{ ...styles.infoVal, color: "#6366f1", textDecoration: "none" }}>
      {customerInfo?.phone
        ? `(${customerInfo.phone.replace(/\D/g,"").slice(0,3)}) ${customerInfo.phone.replace(/\D/g,"").slice(3,6)}-${customerInfo.phone.replace(/\D/g,"").slice(6)}`
        : "—"}
    </a>
  </div>
  <div style={styles.infoRow}>
    <span style={styles.infoKey}>Store Credit</span>
    <span style={{ ...styles.infoVal, color: "#10b981", fontWeight: 700 }}>
      {customerCredit !== null ? `$${Number(customerCredit).toFixed(2)}` : "—"}
    </span>
  </div>
  <div style={styles.infoRow}>
    <span style={styles.infoKey}>Submitted</span>
    <span style={styles.infoVal}>
      {new Date(selected.createdAt).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })}
    </span>
  </div>
</div>

                <div style={styles.section}>
                  <div style={styles.sectionLabel}>RETURN DETAILS</div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoKey}>Reason</span>
                    <span style={styles.infoVal}>{selected.reason}</span>
                  </div>
                  {selected.details && (
                    <div style={styles.detailsBox}>{selected.details}</div>
                  )}
                </div>

                <div style={styles.section}>
                  <div style={styles.sectionLabel}>TIMELINE</div>
                  <TimelineItem label="Submitted"  date={selected.createdAt}   done />
                  <TimelineItem label="Approved"   date={selected.approvedAt}  done={!!selected.approvedAt} />
                  <TimelineItem label="Label Sent" date={selected.labelSentAt} done={!!selected.labelSentAt} />
                  <TimelineItem label="Received"   date={selected.receivedAt}  done={!!selected.receivedAt} />
                  <TimelineItem label="Credited"   date={selected.creditedAt}  done={!!selected.creditedAt} />
                </div>

                <div style={styles.section}>
                  <div style={styles.sectionLabel}>INTERNAL NOTE</div>
                  <textarea
                    style={styles.noteInput}
                    placeholder="Add an internal note..."
                    value={adminNote}
                    onChange={e => setAdminNote(e.target.value)}
                    rows={3}
                  />
                  <button
                    style={styles.noteBtn}
                    onClick={() => action("note", { adminNote })}
                    disabled={actionLoading}
                  >
                    Save Note
                  </button>
                </div>

                <div style={styles.section}>
                  <div style={styles.sectionLabel}>ACTIONS</div>
                  <div style={styles.actionGrid}>

                    {selected.status === "pending" && (
                      <>
                        <ActionBtn label="Approve" color="#3b82f6" onClick={() => action("approve", { adminNote })} disabled={actionLoading} />
                        <ActionBtn label="Deny"    color="#ef4444" onClick={() => action("deny", { adminNote })}    disabled={actionLoading} />
                      </>
                    )}

                    {selected.status === "approved" && (
                      <ActionBtn label="Mark Label Sent" color="#8b5cf6" onClick={() => action("label-sent")} disabled={actionLoading} full />
                    )}

                    {selected.status === "label_sent" && (
                      <ActionBtn label="Mark Item Received" color="#06b6d4" onClick={() => action("received")} disabled={actionLoading} full />
                    )}

                    {selected.status === "received" && (
                      <div style={styles.creditRow}>
                        <input
                          style={styles.creditInput}
                          type="number"
                          placeholder="Credit amount ($)"
                          value={creditAmt}
                          onChange={e => setCreditAmt(e.target.value)}
                          min="0"
                          step="0.01"
                        />
                        <ActionBtn
                          label="Issue Store Credit"
                          color="#10b981"
                          onClick={() => action("issue-credit", { amount: parseFloat(creditAmt) })}
                          disabled={actionLoading || !creditAmt}
                        />
                      </div>
                    )}

                    {selected.status === "credited" && (
                      <div style={styles.creditedNote}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/>
                        </svg>
                        Store credit of <strong>${selected.storeCreditAmount?.toFixed(2)}</strong> issued
                      </div>
                    )}

                    {selected.status === "denied" && (
                      <div style={{ ...styles.creditedNote, color: "#ef4444" }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="15" y1="9" x2="9" y2="15"/>
                          <line x1="9" y1="9" x2="15" y2="15"/>
                        </svg>
                        Return denied
                      </div>
                    )}

                  </div>
                </div>

              </div>
            )}
          </div>

        </div>
      </div>
    </AdminLayout>
  );
}

function StatusBadge({ status, large }) {
  const cfg = STATUS_CONFIG[status] || { label: status, color: "#6b7280", bg: "#f3f4f6" };
  return (
    <span style={{
      background: cfg.bg,
      color: cfg.color,
      border: `1px solid ${cfg.color}30`,
      borderRadius: 999,
      padding: large ? "6px 14px" : "4px 10px",
      fontSize: large ? 13 : 11,
      fontWeight: 700,
      letterSpacing: 0.3,
      whiteSpace: "nowrap",
    }}>
      {cfg.label}
    </span>
  );
}

function TimelineItem({ label, date, done }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
      <div style={{
        width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
        background: done ? "#10b981" : "#f3f4f6",
        border: done ? "none" : "1px solid #e5e7eb",
        display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        {done && (
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12l5 5L20 7"/>
          </svg>
        )}
      </div>
      <span style={{ fontSize: 13, color: done ? "#0f0f17" : "#9ca3af", fontWeight: done ? 600 : 400, flex: 1 }}>
        {label}
      </span>
      {date && (
        <span style={{ fontSize: 11, color: "#9ca3af" }}>
          {new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
        </span>
      )}
    </div>
  );
}

function ActionBtn({ label, color, onClick, disabled, full }) {
  return (
    <button
      style={{
        flex: full ? "unset" : 1,
        width: full ? "100%" : "auto",
        padding: "12px 16px",
        borderRadius: 12,
        border: "none",
        background: color,
        color: "#fff",
        fontSize: 14,
        fontWeight: 700,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "all 0.15s",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

const styles = {
  page: { color: "#0f0f17" },
  header: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 32 },
  kicker: { margin: 0, fontSize: 11, fontWeight: 800, letterSpacing: 2.4, color: "#9ca3af" },
  title: { margin: "4px 0 0", fontSize: 32, fontWeight: 800, letterSpacing: -0.8, color: "#0f0f17" },
  pendingBadge: { background: "#f59e0b", color: "#000", borderRadius: 999, padding: "8px 18px", fontSize: 13, fontWeight: 800 },
  layout: { display: "grid", gridTemplateColumns: "340px 1fr", gap: 20, alignItems: "start" },
  listCol: {},
  filterRow: { display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 },
  filterBtn: { padding: "6px 12px", borderRadius: 999, border: "1px solid #e5e7eb", background: "transparent", color: "#6b7280", fontSize: 12, fontWeight: 600, cursor: "pointer" },
  filterActive: { background: "#0f0f17", color: "#fff", borderColor: "#0f0f17" },
  card: { background: "#fff", border: "1px solid #f3f4f6", borderRadius: 16, padding: "16px 18px", marginBottom: 10, cursor: "pointer", transition: "all 0.15s", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" },
  cardSelected: { background: "#f5f3ff", borderColor: "#c4b5fd" },
  cardTop: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 },
  retNumber: { fontSize: 13, fontWeight: 700, color: "#0f0f17" },
  cardOrder: { fontSize: 12, color: "#9ca3af", marginBottom: 2 },
  cardEmail: { fontSize: 12, color: "#9ca3af", marginBottom: 4 },
  cardReason: { fontSize: 13, color: "#374151", marginBottom: 6 },
  cardDate: { fontSize: 11, color: "#d1d5db" },
  empty: { color: "#9ca3af", fontSize: 14, padding: "20px 0" },
  detailCol: { background: "#fff", borderRadius: 22, border: "1px solid #f3f4f6", minHeight: 500, boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 8px 24px rgba(0,0,0,0.04)" },
  emptyDetail: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 400, gap: 12 },
  emptyDetailText: { color: "#9ca3af", fontSize: 14 },
  detail: { padding: "28px 32px" },
  detailHeader: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 28 },
  detailNumber: { fontSize: 20, fontWeight: 800, color: "#0f0f17", marginBottom: 4 },
  detailSub: { fontSize: 13, color: "#9ca3af" },
  section: { marginBottom: 28, paddingBottom: 28, borderBottom: "1px solid #f3f4f6" },
  sectionLabel: { fontSize: 11, fontWeight: 800, letterSpacing: 2, color: "#9ca3af", marginBottom: 14 },
  infoRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 },
  infoKey: { fontSize: 13, color: "#9ca3af", fontWeight: 500 },
  infoVal: { fontSize: 13, color: "#0f0f17", fontWeight: 600, textAlign: "right" },
  detailsBox: { background: "#f9fafb", borderRadius: 10, padding: "12px 14px", fontSize: 13, color: "#6b7280", lineHeight: 1.6, marginTop: 8 },
  noteInput: { width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 12, padding: "12px 14px", color: "#0f0f17", fontSize: 13, resize: "vertical", fontFamily: "inherit", boxSizing: "border-box", outline: "none" },
  noteBtn: { marginTop: 8, padding: "8px 16px", borderRadius: 10, border: "1px solid #e5e7eb", background: "transparent", color: "#6b7280", fontSize: 13, fontWeight: 600, cursor: "pointer" },
  actionGrid: { display: "flex", gap: 10, flexWrap: "wrap" },
  creditRow: { display: "flex", gap: 10, width: "100%", alignItems: "center" },
  creditInput: { flex: 1, padding: "12px 14px", borderRadius: 12, border: "1px solid #e5e7eb", background: "#f9fafb", color: "#0f0f17", fontSize: 14, outline: "none", fontFamily: "inherit" },
  creditedNote: { display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#10b981", fontWeight: 600 },
};